import React from 'react'

const ProductTableComponent = ({ data, title }) => {
  if (!data.length) return <p>No data available</p>

  const columns = [
    { key: "rank", label: "Rank", align: "left" },
    { key: "category", label: "WTO Product Category", align: "left" },
    { key: "title", label: "Product Title", align: "left" },
    { key: "value", label: "Amount (million USD)", align: "right" },
  ]

  return (
    <div className="chart-wrapper">
      <div className="chart-title">{title}</div>

      <div className="table-scroll">
        <table className="table table-sm">
          
          <thead>
            <tr>
              {columns.map(col => (
                <th
                  key={col.key}
                  style={{ textAlign: col.align }}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row, i) => (
              <tr key={i}>
                {columns.map(col => (
                  <td
                    key={col.key}
                    style={{ textAlign: col.align }}
                  >
                    {row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>

        </table>
      </div>
    </div>
  )
}

export default ProductTableComponent
